import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  ImageItem,
  RequestTemplateContent,
} from "../../../common/statelessView";
import {
  fetchData,
  search,
  closeSlider,
  navigateNow,
  resetPage,
  openSlider,
} from "../../../../_actions/sidebarSliderActions";
import {
  wsCopyFromTemplate,
  wsAddLayer,
} from "../../../../_actions/webSocketAction";
import { connect } from "react-redux";
import SuperList from "../mediaPanel/SuperList";
import { SAVED_TEMPLATES_PANEL } from "../../constants";
import { withTranslation } from "react-i18next";
import { Box, Button, Flex, Text } from "@chakra-ui/react";

class MyTemplates extends Component {
  render() {
    const { sidebarSlider, t } = this.props;
    const { loaded, payload, hasMore } = sidebarSlider;
    let currentTypePayload = payload || [];
    let childElements = currentTypePayload.map((image, index) => {
      let childPayload = this.preparePayload(image);
      return (
        <div
          key={image.id}
          className="item item-element"
          onClick={() => this.addLayerCallback(childPayload)}
          data-grid-groupkey={image.groupKey}
        >
          <ImageItem
            data={childPayload}
            key={image.id}
            url={childPayload.content?.meta.image}
            alt={image.description}
            width={image.image_width}
            height={image.image_width}
            hasAction={true}
            itemWidth={81}
            nativeImageStyles={{height: '81px'}}
            modalFor={
              this.props.panelType === SAVED_TEMPLATES_PANEL
                ? "template"
                : "shape"
            }
            index={index}
            type={"svg"}
          />
        </div>
      );
    });

    const searchPlaceholder =
      this.props.panelType === SAVED_TEMPLATES_PANEL
        ? t("my_template.searchplaceholder")
        : t("my_template.search_saved");

    const noResultFound =
      this.props.panelType === SAVED_TEMPLATES_PANEL
        ? t("my_template.no_templates_found")
        : t("my_template.no_saved_comp");

    return (
      <>
        <SuperList
          list="element-gallery"
          loaded={loaded}
          searchPlaceholder={searchPlaceholder}
          notFound={
            <div className="no-content-container">
              <RequestTemplateContent
                text={noResultFound}
              ></RequestTemplateContent>
            </div>
          }
          hasMore={hasMore}
          loadPage={this.loadPage}
        >
          {childElements}
        </SuperList>
      </>
    );
  }

  loadPage = (groupKey) => {
    const { searchText } = this.props.sidebarSlider;
    if (!searchText) {
      this.props.fetchData("", {
        ...this.props,
        groupKey: groupKey,
      });
    } else {
      this.props.search("", searchText, {
        ...this.props,
        groupKey,
      });
    }
  };

  preparePayload = (data) => {
    const message = {
      mime: "shape",
      id: data.id,
      type: "component",
      content: {
        meta: {
          ...data,
        },
      },
    };
    return message;
  };

  addLayer = (data) => {
    this.props.wsCopyFromTemplate(this.props.editor.activePage.id, data.id);
  };

  addLayerCallback = async (data) => {
    this.addLayer(data);
    if (this.props.isMobileView) {
      this.props.closeSlider();
    }
  };
}

MyTemplates.propTypes = {
  page: PropTypes.number.isRequired,
  sidebarSlider: PropTypes.object.isRequired,
  categoryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  categoryType: PropTypes.string,
};

MyTemplates.defaultProps = {
  org: "",
  page: 1,
};

const mapStateToProps = (state) => ({
  sidebarSlider: state.sidebarSlider,
  editor: state.editor,
  contentSize: state.story.contentSize,
  page: state.sidebarSlider.page,
  org: state.auth.payload.selectedOrg,
  panelType: state.sidebarSlider.sliderPanelType,
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = (dispatch) => ({
  fetchData: (source, props) => dispatch(fetchData(source, props)),
  search: (source, searchTerm, props) =>
    dispatch(search(source, searchTerm, props)),
  wsCopyFromTemplate: (activePageId, payload) =>
    dispatch(wsCopyFromTemplate(activePageId, payload)),
  wsAddLayer: (activePageId, payload) =>
    dispatch(wsAddLayer(activePageId, payload)),
  closeSlider: () => dispatch(closeSlider()),
  navigateNow: (payload) => dispatch(navigateNow(payload)),
  resetPage: (payload) => dispatch(resetPage(payload)),
  openSlider: (panel) => dispatch(openSlider(panel)),
});

export default withTranslation(["studio", "folders"])(
  connect(mapStateToProps, mapDispatchToProps)(MyTemplates)
);
